module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"select_salesperson":"Select Salesperson"},"id":{"select_salesperson":"Pilih Salesperson/Penjual"}}')
  delete Component.options._Ctor
}
